/**
 * Mando UI initialisation
 */

/* eslint-disable */
import Vue from "NodeModules/vue/dist/vue.min.js";

// Simple observable event bus to allow communication between components
Vue.prototype.$eventBus = new Vue();

import moment from "NodeModules/moment/moment";
import polyfillClosest from '../polyfill';
import search from 'Components/searches/search/mando-ui.search';
import cookieBanner from 'Components/searches/_cookie/mando-ui.cookie';
import share from 'Components/searches/share/mando-ui.share';
import accordion from 'Components/searches/accordion/mando-ui.accordion';
import table from 'Components/searches/_rte-table/mando-ui.rte-table';
import tabs from 'Components/searches/tabs/mando-ui.tabs';
import videoHero from 'Components/searches/hero/mando-ui.video-hero';
import heroCarousel from 'Components/searches/hero/mando-ui.hero-carousel';
import searchResults from 'Components/searches/results/SearchResults.vue';
import headerAltOne from 'Components/searches/header/header';
import navigationAltOne from 'Components/searches/navigation/navigation';

document.addEventListener('DOMContentLoaded', () => {
  // Add JS helper class
  document.getElementsByTagName('html')[0].classList.remove('no-js');
  document.getElementsByTagName('html')[0].classList.add('has-js');

  //* Polyfill
  polyfillClosest();

  // Components 
  headerAltOne();
  navigationAltOne();
  search();
  cookieBanner();
  share();
  accordion();
  table();
  videoHero();
  heroCarousel();
  tabs();

  const searchResultsEl = document.querySelector('#search-results');

  Vue.filter('formatDate', (value) => {
    if (!value) {
      return '';
    }
    return moment(value).format('DD/MM/YY');
  });

  Vue.filter('formatFileSize', (value) => {
    return `${(value / Math.pow(1024, 1)).toFixed(2)}kB`;
  });

  Vue.filter('booleanToYesNo', value => ((value) ? 'Yes' : 'No'));

  if (searchResultsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#search-results',
      render: h => h(searchResults, {
        props: {
          categories: JSON.parse(searchResultsEl.dataset.categories),
          componentId: searchResultsEl.dataset.componentId,
          siteId: searchResultsEl.dataset.siteId,
        },
      }),
    });
    /* eslint-enable */
  }
});


// WEBPACK FOOTER //
// ./src/scripts/brands/searches.js